import Icon from 'ms-ui-primitives/Icon';

import type { Props } from '../types';

const DifficultyEasy = ({
  color,
  size,
  title,
  titleId,
  aphroditeStyles = [],
}: Props) => (
  <Icon
    color="none"
    size={size}
    aphroditeStyles={aphroditeStyles}
    title={title}
    titleId={titleId}
    viewBoxWidth={24}
    viewBoxHeight={24}
  >
    <mask
      id="b"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="2"
      y="4"
      width="20"
      height="16"
    >
      <mask id="a" fill="#fff">
        <path d="M2 14a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-4ZM9 10a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-8ZM16 6a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V6Z" />
      </mask>
      <path
        d="M2 14a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-4Z"
        fill="#000"
      />
      <path
        d="M2 14a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-4ZM9 10a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-8ZM16 6a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V6Z"
        stroke="#000"
        strokeWidth="3"
        mask="url(#a)"
      />
    </mask>
    <g mask="url(#b)">
      <path fill={color} d="M0 0h24v24H0z" />
    </g>
  </Icon>
);
DifficultyEasy.displayName = 'DifficultyEasy';

export default DifficultyEasy;
